<template>
    <div>
        <el-form
            v-if="formData"
            :model="formData"
            ref="formData"
            label-position="top"
            class="MT20"
        >
             <el-card v-if="formData && formData.playTime" shadow="never">
                <ul>
                    <!-- <li v-if="formData.createTime"><span class="color-info">申请结款时间: </span>{{formData.createTime}}</li> -->
                    <li v-if="formData.playUserName" class="MT10"><span class="color-info">结款信息提交人: </span> {{formData.playUserName}}</li>
                    <li v-if="formData.playTime" class="MT10"><span class="color-info">打款时间: </span>{{formData.playTime}}</li>
                    <!-- <li  v-if="formData.applyDesc" class="MT10"><span class="color-info">申请结款备注: </span>{{formData.applyDesc}}</li> -->
                </ul>
            </el-card>
            <el-row :gutter="20" class="MT10">
                <el-col :span="12">
                    <el-form-item prop="playPriceTicketFormat" label="实际打款金额(￥):" :rules="[{required:true,message:'请填写实际打款金额'}]">
                        <!-- <el-input v-model="formData.playPriceTicketFormat" type="number" :max="formData.saleAmountFormat" size="medium" placeholder="请填写打款金额" :disabled="formData.status == 2"></el-input> -->
                        <el-input-number style="width:100%" v-model="formData.playPriceTicketFormat" :precision="2" controls-position="right" :min="0.00" :max="99999999.99" size="medium" placeholder="请填写打款金额" :disabled="formData.status == 2"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="playPriceNo" label="打款流水号:" :rules="[{required:true,message:'请填写打款流水号'}]">
                        <el-input v-model="formData.playPriceNo" maxlength="50" size="medium" placeholder="请填写打款流水号" :disabled="formData.status == 2"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item prop="playPic">
                <span slot="label">打款截图: <small>支持格式为JPG、PNG,不大于10M,最多上传3张</small></span>   
                <div>
                    <el-upload
                        action
                        list-type="picture-card"
                        accept="image/png,image/jpeg"
                        :file-list="formData.fileList"
                        :http-request="uploadImage"
                        :on-remove="handleRemove"
                        :before-upload="beforeUpload"
                        :disabled="uploadLoading || formData.status == 2"
                        :limit="3"
                        :on-exceed="handleExceed">
                        <el-progress v-if="progress && progress < 100" :width="120" type="circle" :percentage="progress"></el-progress>
                        <i v-else class="el-icon-plus"></i>
                    </el-upload>
                </div>
            </el-form-item>
            <el-form-item prop="playDesc" label="打款备注:">
                <el-input v-model="formData.playDesc" type="textarea" :rows="2" maxlength="100" show-word-limit placeholder="请填写打款备注"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {uploadImg} from '@/assets/js/commonApi.js';
const defaultFormData = {
    playDesc:'',
    playPriceNo:'',
    playPic:[],
    playPriceTicketFormat:''
}
export default {
    props:{
        formData:{
            type: Object,
            default: {
                ...defaultFormData
            }
        },
        btnLoading: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            uploadLoading: false,
            progress:null,
        }
    },
    methods:{
        
        handleExceed(files, fileList) {
            this.$message.warning('最多上传3张图片');
        },
        handleRemove(file, fileList) {
            const _index = this.formData.fileList.findIndex(v => v === file);

            this.formData.playPic = this.formData.playPic.filter( (v,i) => i !== _index);

            this.formData.fileList = fileList; 
        },
        beforeUpload(file){
            this.formData.fileList = this.formData.fileList.filter( v => v !== file)
        },
        async uploadImage(req){
            const {
                file,
                file: { type, size },
            } = req;

            //格式检查
            const formatVerified =
                type === "image/jpeg" || file.type === "image/png";
            if (!formatVerified) {
                this.$message.error("图片格式错误,请重新上传");
                return;
            }
            //大小检查
            const bytesVerified = size / 1024 / 1024 < 10;
            if (!bytesVerified) {
                this.$message.error("图片尺寸错误,请重新上传");
                return;
            }

            // 上传图片
            const formData = new FormData();
            formData.append("file", file);
             
            this.uploadLoading = true;
            const res = await uploadImg(formData,ev => {
                this.progress = Math.floor((ev.loaded / ev.total) * 100);
            }).finally(() => {
                this.uploadLoading = false;
            });

            const {state,result,msg} = res.data;
            if(state == 1){
                this.formData.fileList.push({
                    url:result.urlFull
                });
                this.formData.playPic.push(result.url);
            }else{
                this.$message.error( msg || '上传失败');
            }
        },
        onSubmit(callback){
            if(this.$refs.formData) {
                this.$refs["formData"].validate((valid) => {
                    if (valid) {
                        this.$confirm('确定提交结款信息？', '提示', {
                            type: 'warning',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$emit('update:btnLoading', true) ;
                            this.$request({
                                url: '/agent/settle/receivables',
                                data: {...this.formData,id: this.formData.activityId,},
                                method: "post",
                            })
                                .then((res) => {
                                    const { state, msg } = res.data;
                                    if (state == 1) {
                                        if(callback) callback();
                                        this.$refs.formData.resetFields();
                                    } else {
                                        this.$message.error(msg || "操作失败,请重试");
                                    }
                                })
                                .catch(() => {
                                    this.$message.error("操作失败,请重试");
                                })
                                .finally(() => {
                                    this.$emit('update:btnLoading', false) ;
                                });
                        }).catch(() => {})    
                    } else {
                        return false;
                    }
                });
            }else{
                if(callback) callback();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.info-table{
    .el-image{
        width: 60px;
        height: 60px;
        margin-right: 5px;
    }
}
</style>